export type CwRowVisibilityItem = {
  watched?: boolean | null
}

export function isVisibleCwRowItem(item: unknown): item is CwRowVisibilityItem {
  return (
    typeof item === 'object' &&
    item !== null &&
    (!('watched' in item) || item.watched !== true)
  )
}
